import { API_URL_BASE } from './';

const getWidgetConfiguration = async () => {
    try {
        const config = sessionStorage.getItem(process.env.TCC_SESSION_STORAGE_WIDGET_CONFIG);
        if (config) {
            return JSON.parse(config);
        }

        const options = {
            method: 'POST',
            headers: {
                'Content-type': 'Application/json'
            },
            body: JSON.stringify({
                api_key: process.env.WIDGET_API_KEY
            })
        };

        const request = await fetch(`${API_URL_BASE}/public_token`, options);
        const json = await request.json();

        if (!sessionStorage.getItem(process.env.TCC_SESSION_STORAGE_WIDGET_CONFIG)) {
            sessionStorage.setItem(process.env.TCC_SESSION_STORAGE_WIDGET_CONFIG, JSON.stringify(json));
        }

        return json;
    } catch (e) {
        console.log('Failed to get widget configuration', {
            app: 'chatbot',
            error: e
        });
    }
};

export default {
    getWidgetConfiguration
};
